// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"545": "vendors","577": "__federation_expose_useHostAuthState",}[chunkId] || chunkId) + "-" + {"106": "1d036824511e1be6","122": "2c7bfc488a4c79ca","545": "cd2ae4823eeba78d","577": "38ae27adb57ed741",}[chunkId] + ".bundle.js"
}